import { CVV_ERROR_STATUS } from "api/interfaces/reportInterface.interface";
import * as s from "./ThumbnailStyled";
import { useState } from "react";
import { TbDeviceComputerCameraOff, TbPhotoOff } from "react-icons/tb";
import { PiVideoCameraSlash } from "react-icons/pi";
import { LuCalendarClock } from "react-icons/lu";

type ThumbnailErrorProps = {
  isRecorderList?: boolean;
  errorStatus?: string;
  transparent?: boolean;
};

export default function ThumbnailError(props: ThumbnailErrorProps) {
  const [errorString] = useState(() => {
    switch (props.errorStatus) {
      case CVV_ERROR_STATUS.THUMBNAIL_NOT_AVAILABLE:
        return "Thumbnail is Not Available";
      case CVV_ERROR_STATUS.CAMERA_INVALID:
        return "Camera is Invalid";
      case CVV_ERROR_STATUS.CAMERA_OFFLINE:
        return "Camera is Offline";
      case CVV_ERROR_STATUS.CAMERA_UNAUTHORIZED:
        return "Camera is Unauthorized";
      case CVV_ERROR_STATUS.CAMERA_NOT_RECORDING:
        return "Camera is Not Recording";
      case CVV_ERROR_STATUS.JPEG_ENCODING_FAILED:
        return "Jpeg Encoding Failed";
      case CVV_ERROR_STATUS.RECORDER_NOT_RESPONDING:
        return "Recorder is Not Responding";
      case CVV_ERROR_STATUS.RECORDER_AUTH_FAIL:
        return "Recorder Auth Failure";
      case CVV_ERROR_STATUS.THUMBNAIL_ERROR:
        return "Thumbnail Upload Failed";
      case CVV_ERROR_STATUS.UPDATE_SCHEDULED:
        return "Update Scheduled";
      case CVV_ERROR_STATUS.VIDEO_LOSS:
        return "Video Loss";
      case CVV_ERROR_STATUS.CAMERA_RESPONSE_FAILURE:
        return "Camera Response Failure";
      default:
        return "Thumbnail Not Available";
    }
  });
  const [errorIcon] = useState(() => {
    if ((props.errorStatus || "").includes("Camera")) {
      return <TbDeviceComputerCameraOff size={24} />;
    } else if ((props.errorStatus || "").includes("Recorder")) {
      return <PiVideoCameraSlash size={24} />;
    } else if ((props.errorStatus || "").includes("Scheduled")) {
      return <LuCalendarClock size={24} />;
    } else {
      return <TbPhotoOff size={24} />;
    }
  });
  return (
    <s.Container
      className="video-loss-image"
      transparent={props.transparent}
      isRecorderList={props.isRecorderList}
      danger={
        (props.errorStatus || "").includes("Fail") ||
        (props.errorStatus || "").includes("Error") ||
        props.errorStatus === CVV_ERROR_STATUS.VIDEO_LOSS
          ? "danger"
          : (props.errorStatus || "").includes("Scheduled")
          ? "scheduled"
          : undefined
      }
    >
      {errorIcon}
      <p>{errorString}</p>
    </s.Container>
  );
}
